<template>
    <div class="background">

      <el-card class="box-card">

        <div class="contentclass" style="display: flex;margin-top:10px">
        
              <div style="flex: 1;">
                <div style="padding:5px">
                  
                    <div style="font-size: 18px;color: #515666;text-align:center;margin-top:20px">欢迎使用精灵物联网平台</div>

                    <div style="font-size: 18px;color: #515666;text-align:center;margin-top:20px">
                  
                  <el-input
                  style="width:250px;height:35px;margin-top:20px"
                   placeholder="请输入账号"
                   v-model="form.phonenumber"
                   maxlength="11"
                   type="text"
                   >

                  </el-input>


                    <el-input
                  style="width:250px;height:35px;margin-top:20px"
                     placeholder="密码"
                     v-model="form.password"
                     type="password"
                     show-password
                     >
                    </el-input>


                       <el-button style="width:250px;height:40px;margin-top:20px;color:#fff" type="primary"    @click="login">登录</el-button>

                      

                    </div>
           
                </div>

              </div>


              
              <div style="margin:15px; "> 
                  <img style="width:250px;height:250px;" src="../assets/login_compute.png">
              </div>

            </div>
      
      </el-card>
    
    
    <div class="icp">© 2024 FairyCloud  <a href="http://beian.miit.gov.cn/" target="_blank"> 京ICP备19050883号-2</a>  <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank"> 京公网安备11010602201065号</a></div>


    </div>

</template>

<script>

import {mapMutations} from 'vuex'
import TMApipath from 'TMApipath'

import {isJsonType} from 'TMUtils'


export default {
  name: 'Login',
  data () {
    return {
      form: {
        phonenumber: '',
        password: '',
        clienttype:"iiotweb"
      }
    }
  },
  methods: {
    ...mapMutations([
      'VUEX_USER_ACCOUNT',
      'VUEX_USER_WEBFUNC'
    ]),
    login () {
      var _this = this

      _this.form.password =  _this.form.password.trim()
      _this.form.phonenumber =  _this.form.phonenumber.trim()


      if(!(/^1\d{10}$/.test(_this.form.phonenumber))) {
        _this.$message.error("请输入正确的账号");
        return;
      }



      const rule = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/;
   
      var resultpwd = rule.test(_this.form.password);
      


      if ( _this.form.password.length<8 || _this.form.password >30 ) {
          this.$message.error("请输入符合长度8~30位的密码");
        return
      }
      
      if (!resultpwd ) {
          this.$message.error("请输入符合系统规定的密码,包含大写字母、小写字母、数字和特殊符号中的任意三种");
        return
      }

      var params = {
        phonenumber: _this.form.phonenumber,
        password: _this.form.password,
        clienttype: _this.form.clienttype,
      }

      var reqdata = {}
      var { urls} = _this.getresult(TMApipath.USER,TMApipath.URL_API_LOGIN, reqdata);


      let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


      _this.axios.post(urls, params).then((response) => {
        
        _this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });

        if (response.status ) {

          var account= response.data

          if (account.resetpwd == 1) {
                      // vuex记录
              _this.VUEX_USER_ACCOUNT(account)
              _this.getRoleByRole(account.token,account.role)
        
          } else {
          _this.$message.success("第一次登录系统，请修改密码！");

          setTimeout(function() {
               _this.$router.push("/ResetPwd")
          }, 2000);



          }


        }else{
          _this.$message.error(response.msg);
        }


      }, (response) => {

        _this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });

        console.log(response)
      });


    },
    getRoleByRole(token,role){

    var _this = this;
    var reqdata = {
        token:  token, role: role
      }


      var { urls} = _this.getresult(TMApipath.USER, TMApipath.URL_API_GETROLEBYROLE, reqdata);


        let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });
      _this.axios.get(urls).then((response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        if (response.status) {
          // vuex记录
          // _this.groupIist = [];
          
           if (!isJsonType(response.data.webfunc)) {
              console.log('result为null，或不是json')
              return
            }
             var webfunc = JSON.parse(response.data.webfunc);
             _this.VUEX_USER_WEBFUNC(webfunc)

               _this.$router.push("/home/")
                               
        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        console.log(response)
      });
    },



  }
}
</script>


<style lang="stylus" scoped>

.background
    position: absolute;
    min-width: 1140px;
    width: 100%;
    height: 100%;
    background: #fff url(../assets/login_bg.png) no-repeat bottom;
    background-size: cover;
    min-height: 748px;

    display:flex;
    justify-content:center;
    align-content:center;
    align-items:center;

.titleclass
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
.contentclas1s
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 400px;
.titletext
    font-size:45px;
    font-weight:bold;
    color:#970B0B;
.box-card {
    width: 680px;
    height:400px;
}

body {
    display: block;
    margin: 0px;
}

.icp {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 5px 0;
    width: 100%;
    height: 30px;
    white-space: pre;
    text-align: center;
    color: #aaa;
    z-index: 1000;
    font-size: 15px;
}
.icp > a {
    color: #aaa;
    text-decoration: none;
}
.icp > a:hover {
    color: #aaa;
    text-decoration: none;
}
</style>
